import { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { useNavigate } from 'react-router';
import { gridSpacing } from 'store/constant';
import { getApi } from 'views/services/api';
import FinancialMetrics from './FinancialMetrics';
import TarjetaTotalReservaciones from './TotalReseravtions';
import TarjetaTotalHoteles from './TotalHotels';
import TarjetaTotalHabitaciones from './TotalRooms';
import GestionHoteles from 'views/HotelManagement';
import OnboardingFunnel from './OnboardingFunnel';
import SaasMetricsPanel from './SaasMetricsPanel';

const DashboardAdmin = () => {
  const [estaCargando, setEstaCargando] = useState(true);
  const [datosHoteles, setDatosHoteles] = useState(0);
  const [datosReservaciones, setDatosReservaciones] = useState(0);
  const [datosClientes, setDatosClientes] = useState(0);
  const [datosSaaS, setDatosSaaS] = useState(null);
  const [datosHabitaciones, setDatosHabitaciones] = useState(0);
  const navigate = useNavigate();

  // Función para obtener todos los datos de hoteles de la base de datos
  const obtenerDatosHoteles = async () => {
    try {
      const respuesta = await getApi('api/hotel/viewallhotels');
      setDatosHoteles(respuesta?.data);
    } catch (error) {
      console.error('Error al obtener datos de hoteles:', error);
    }
  };

  // Función para obtener todas las reservaciones
  const obtenerDatosReservaciones = async () => {
    try {
      const respuesta = await getApi('api/reservation/viewallreservation');
      setDatosReservaciones(respuesta?.data?.reservationData);
    } catch (error) {
      console.error('Error al obtener datos de reservaciones:', error);
    }
  };

  // Función para obtener todos los clientes
  const obtenerDatosClientes = async () => {
    try {
      const respuesta = await getApi('api/customer/viewallcustomer');
      setDatosClientes(respuesta?.data?.customerData);
    } catch (error) {
      console.error('Error al obtener datos de clientes:', error);
    }
  };

  // Función para obtener métricas SaaS
  const obtenerMetricasSaaS = async () => {
    try {
      const respuesta = await getApi('api/hotel/saas-metrics');
      setDatosSaaS(respuesta?.data);
    } catch (error) {
      console.error('Error al obtener métricas SaaS:', error);
    }
  };

  // Función para obtener todas las habitaciones
  const obtenerDatosHabitaciones = async () => {
    try {
      const respuesta = await getApi('api/room/viewallrooms');
      setDatosHabitaciones(respuesta?.data);
    } catch (error) {
      console.error('Error al obtener datos de habitaciones:', error);
    }
  };

  // Efecto para cargar todos los datos al montar el componente
  useEffect(() => {
    const cargarDatos = async () => {
      setEstaCargando(true);
      await Promise.all([
        obtenerDatosHoteles(),
        obtenerDatosReservaciones(),
        obtenerDatosClientes(),
        obtenerDatosHabitaciones(),
        obtenerMetricasSaaS()
      ]);
      setEstaCargando(false);
    };

    cargarDatos();
  }, []);

  const manejarClickHotel = () => {
    navigate('/dashboard/hotel');
  };

  return (
    <Grid container spacing={gridSpacing}>
      <Grid item xs={12}>
        <Grid container spacing={gridSpacing}>
          <Grid item lg={3} md={6} sm={6} xs={12} sx={{ cursor: 'pointer' }} onClick={manejarClickHotel}>
            <TarjetaTotalHoteles isLoading={estaCargando} hotelData={datosHoteles} />
          </Grid>

          <Grid item lg={3} md={6} sm={6} xs={12}>
            <FinancialMetrics isLoading={estaCargando} metricsData={datosSaaS} />
          </Grid>

          <Grid item lg={3} md={6} sm={6} xs={12}>
            <TarjetaTotalHabitaciones isLoading={estaCargando} roomData={datosHabitaciones} />
          </Grid>

          <Grid item lg={3} md={6} sm={6} xs={12}>
            <TarjetaTotalReservaciones isLoading={estaCargando} reservationData={datosReservaciones} />
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12} lg={8}>
        <SaasMetricsPanel isLoading={estaCargando} metricsData={datosSaaS} onRefresh={obtenerMetricasSaaS} />
      </Grid>

      <Grid item xs={12} md={6} lg={4}>
        <OnboardingFunnel isLoading={estaCargando} metricsData={datosSaaS} />
      </Grid>

      <Grid item xs={12}>
        <GestionHoteles />
      </Grid>
    </Grid>
  );
};

export default DashboardAdmin;
